const ASTRAL_SYMBOLS_REGEX = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;

export function encode(value: string) {
  return value
    .replace(ASTRAL_SYMBOLS_REGEX, s => {
      const high = s.charCodeAt(0);
      const low = s.charCodeAt(1);
      const codePoint = (high - 0xd800) * 0x400 + low - 0xdc00 + 0x10000;
      return `&#${codePoint};`;
    })
    .replace(/([^#-~ |!])/g, s => {
      return `&#${s.charCodeAt(0)};`;
    });
}
